import classnames from 'classnames';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

import { AsyncSelect, OptionType, Select } from '@components/Select';

import '@components/mixins/commonStyles.scss';
import style from './SnomedPage.module.scss';
import { CommonTestAttributes } from 'chaika-test-attributes';

export interface SnomedPageProps {
    snomedCTName: Nullable<OptionType>;
    snomedICDName: Nullable<OptionType>;
    isICDDisabled: boolean;
    snomedCTDefaultOptions: OptionType[];
    snomedICOptions: OptionType[];
    onSearchLoadOptions(inputValue: string): void;
    onSearchChange(params: OptionType): void;
    onIcdChange(params: OptionType): void;
}

export function SnomedPage({
    snomedCTName,
    snomedICDName,
    snomedCTDefaultOptions,
    snomedICOptions,
    isICDDisabled,
    onSearchLoadOptions,
    onSearchChange,
    onIcdChange,
}: SnomedPageProps) {
    return (
        <div className={style.root}>
            <div className={style.title}>
                <div className={classnames(['font_h1'])}>SNOMED 🤝 ICD</div>
                <div className={classnames(['font_caption', style.logoRight])}>ICD-10</div>
            </div>

            <div>
                <div className={style.block}>
                    <div className={classnames(['font_h1', style.blockTitle])}>1. Choose SNOMED CT name</div>
                    <AsyncSelect
                        isClearable
                        dataTest={CommonTestAttributes.Unknown}
                        placeholder={'Search'}
                        selectedValue={Number(snomedCTName?.value)}
                        defaultOptions={snomedCTDefaultOptions}
                        loadOptions={onSearchLoadOptions}
                        onChange={onSearchChange}
                    />
                </div>
                <div className={style.block}>
                    <div className={classnames(['font_h1', style.blockTitle])}>2. Now choose ICD code</div>
                    <Select
                        isClearable
                        dataTest={CommonTestAttributes.Unknown}
                        disabled={isICDDisabled}
                        placeholder={'Choose'}
                        selectedValue={Number(snomedICDName?.value)}
                        options={snomedICOptions}
                        onChange={onIcdChange}
                    />
                </div>
                <div className={style.block}>
                    <div className={classnames(['font_h1', style.blockTitle])}>3. Profit</div>
                    <div className={classnames([style.result, snomedCTName && snomedICDName && style.resultSuccess])}>
                        {snomedCTName ? (
                            <div>
                                <div>
                                    <div className={'font_body16Gray'}>SNOMED CT name</div>
                                    <div className={'font_body16Black'}>{snomedCTName.label}</div>
                                    <div className={'font_body16Gray'}>{snomedCTName.additionalText}</div>
                                </div>
                                {snomedICDName && (
                                    <div className={style.icdResult}>
                                        <div className={'font_body16Gray'}>ICD Code</div>
                                        <div className={style.icdResultContent}>
                                            <div>{snomedICDName.label}</div>
                                            <div>{snomedICDName.highlightText}</div>
                                        </div>
                                        <div>{snomedICDName.additionalText}</div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className={style.noResult}>Not yet</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
